import React from 'react'
import classNames from 'classnames'

import { InlineIcon } from '@iconify/react'
import fileZipOutlined from '@iconify/icons-ant-design/file-zip-outlined'

import { getDateFromServerDate, getDateTimeForWeb, setLocalTimezone } from 'utils/date'

import Button from 'components/molecules/Button'
import styles from './FileItem.module.css'

import { FileProps } from '../../../../../types/file'

type FileItemProps = { file: FileProps; onRestore: (file: FileProps) => void; deleteLoading?: boolean }

export const FileItem: React.FC<FileItemProps> = ({ file, onRestore, deleteLoading }) => {
  const { uuid, name, createdAt } = file

  return (
    <div className={classNames(styles.galleryItem, uuid ? styles.hasButDownload : '', 'd-flex align-items-center mb-1')}>
      <div className="d-flex align-items-center w-100">
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex' }}>
            <InlineIcon icon={fileZipOutlined} width={24} height={24} style={{ marginRight: '8px' }} />
            <div className={styles.galleryItemFileName}>{name}</div>
          </div>
        </div>
        {createdAt ? <span className="text-secondary">{getDateTimeForWeb(setLocalTimezone(getDateFromServerDate(createdAt || '')))}</span> : null}
        <Button isLoading={deleteLoading} onClick={() => onRestore(file)} variant="outline-dark" className="ml-2">
          Восстановить
        </Button>
      </div>
    </div>
  )
}

export default FileItem
